import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const PaynamicsResponseHandler = () => {
  const { orderId, responseId } = useParams(); // Assuming orderId and responseId are passed as URL parameters
  
  const [status, setStatus] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Make API call to your WordPress backend to handle the Paynamics response
    const handlePaynamicsResponse = async () => {
      try {
        const response = await axios.post('/wp-json/update-order-status', {
          orderId,
          responseId,
        });
        setStatus('success');
        setMessage(response.data.message);
      } catch (error) {
        setStatus('error');
        setMessage('Failed to update order status.');
      }
    };

    handlePaynamicsResponse();
  }, [orderId, responseId]);

  return (
    <div>
      {status === 'success' ? (
        <p>{message}</p>
      ) : status === 'error' ? (
        <p>Error: {message}</p>
      ) : (
        <p>Processing...</p>
      )}
    </div>
  );
};

export default PaynamicsResponseHandler;
